import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="border-t-2 border-coral/30 bg-carbon" data-id="element-159" data-mp="1n0aczfdwoovk">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-7" data-id="element-160" data-mp="1r146coa4avvu">
        <Reveal className="text-center" data-id="element-161" data-mp="1d1unfguj1no6">
          <h2 id="testimonios" className="font-display text-2xl uppercase leading-none tracking-wide text-cream sm:text-4xl" data-id="element-162" data-mp="1d0tb791ryv4v">
            Lo que dicen quienes ya empezaron
          </h2>
          <p className="mt-1 text-[0.82rem] font-bold text-coral sm:text-base" data-id="element-163" data-mp="142r4ccvd189o">
            De entrenar sin estructura a comprender cómo organizar una rutina.
          </p>
        </Reveal>

        <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-164" data-mp="2ygikzwc3wsem">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-nude/20 bg-carbon-soft p-3.5" data-id="element-165" data-mp="32fzq2onmfnj9" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-166" data-mp="2q0n7o62sl5rm">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-167" data-mp="34qulu9lro2mi">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={13} className="fill-gold text-gold" data-id="element-168" data-mp="2c2q8r30v8n9s" data-mpi={s} />)}
                </div>
                <QuoteIcon size={16} className="text-coral/50" aria-hidden="true" data-id="element-169" data-mp="2m0mipri2hc6b" />
              </div>
              <p className="mt-1.5 text-[0.79rem] leading-snug text-cream sm:text-[0.84rem]" data-id="element-170" data-mp="2h45yh8dznhyi">
                “{item.text}”
              </p>
              <div className="mt-auto pt-2" data-id="element-171" data-mp="3shrkikojx3ft">
                <p className="font-display text-base uppercase tracking-wide text-coral" data-id="element-172" data-mp="3sj2puoxnaj91">
                  {item.name}
                </p>
                <p className="text-[0.68rem] text-muted sm:text-xs" data-id="element-173" data-mp="8dc4pwbrg9ep">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}